<script setup lang="ts">
import { parseJournalSectionPath } from '~/shared/lib/journal-routes.const';
import JournalPage from './JournalPage.vue';
import JournalIssuePage from './JournalIssuePage.vue';
import JournalYearPage from './JournalYearPage.vue';

/**
 * One catch-all route serves the whole section, so the address is what tells
 * the screens apart: a last segment of 'i881' is an issue, 'y2025' an archive
 * year, anything else a tab, an edition or the media kit — JournalPage sorts
 * those out against the reference (ADR 0001, decision 26)
 */
const route = useRoute();

const kind = computed(() => parseJournalSectionPath(route.path).kind);
</script>

<template>
  <JournalIssuePage v-if="kind === 'issue'" :key="route.path" />
  <JournalYearPage v-else-if="kind === 'year'" :key="route.path" />
  <JournalPage v-else />
</template>
